import { create } from 'zustand';

interface UIState {
  sidebarOpen: boolean;
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  toggleCollapsed: () => void;
  
  // Download state
  isDownloading: boolean;
  downloadProgress: string; // e.g., "Generating PDF..." or "Downloaded"
  setIsDownloading: (loading: boolean, progress?: string) => void;
}

export const useUIStore = create<UIState>()((set) => ({
  sidebarOpen: false,
  sidebarCollapsed: false,
  isDownloading: false,
  downloadProgress: '',

  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleCollapsed: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  
  setIsDownloading: (loading, progress = '') => set({ 
    isDownloading: loading, 
    downloadProgress: progress 
  }),
}));
